import { render } from "./LearnerComponent.vue?vue&type=template&id=3a2748cc&scoped=true"
import script from "./LearnerComponent.vue?vue&type=script&lang=js"
export * from "./LearnerComponent.vue?vue&type=script&lang=js"

import "./LearnerComponent.vue?vue&type=style&index=0&id=3a2748cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2748cc"]])

export default __exports__